import React, { useState } from 'react'
import './code-view.css'
import copylink from '../../assets/copylink.svg'

const CodeView: React.FunctionComponent<{ code?: {}, text: any, showRunButton?: boolean, showdropDownButton?: Boolean, copyValue: any }> = ({ code, text, copyValue, showRunButton, showdropDownButton }) => {

  const [copyText, setCopyText] = useState('copy')
  const [runText] = useState('Run')

  const copyToClipboard = async () => {
    const textToCopy = Array.isArray(copyValue) ? JSON.stringify(copyValue, null, 2) : copyValue;

    if (window.isSecureContext) {
        try {
            await navigator.clipboard.writeText(textToCopy);
            setCopyText('Copied!!!');
            setTimeout(() => setCopyText('Copy'), 2000);
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
    } else {
        console.warn('Clipboard API is not available in this context.');
    }
};


  return (
    <div className="code-view-container p-3  position-relative">

      <div className="copy-btn-container ">
        <button onClick={copyToClipboard} type='button' className='border-0  text-capitalize text-white font-14 weight-400'>{copyText}<img width={10} height={10} className="icon-white ms-1" src={copylink} alt="add" /></button>
        {showdropDownButton && (
          <div className="btn-group custom-drop ">
            <button className="btn btn-secondary btn-sm dropdown-toggle ms-2 node-dropdown-btn border-0 text-capitalize text-white font-14 weight-400" type="button" data-bs-toggle="dropdown" aria-expanded="false">
              <span className='font-12 '>Node.js</span>
            </button>
            <ul className="dropdown-menu dropdown-menu-custom py-0 " aria-labelledby="dropdownMenuLink">
              <li><a className="dropdown-item " href="#">Node.js</a></li>
            </ul>
          </div>

        )}
      </div>

      <div className="code-view mt-4">
        <div className="text-white custom-add font-13" dangerouslySetInnerHTML={{ __html: text }} />
      </div>
      {showRunButton && (
        <div className="run-btn-container">
          <button type='button' className='border-0 px-5 RunButton text-capitalize text-white font-12 py-2 weight-400'>{runText}</button>
        </div>
      )}
    </div>
  )
}

export default CodeView
